import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { Title, Empty } from 'src/components/Ant'

import { WrapSpacer, WrapTableDiv } from './styles'
import { Footer, OptionsBar, TitleReport } from '..'
import { WrapPageContent, WrapPage } from '../../styles'
import {
  SectionHeader,
  SectionReceipts,
  SectionTotal,
  TableDetail
} from './components'
import { A4_PORTRAIT } from 'src/views/Management/Reports/types'

enum mesures {
  A4_PORTRAIT = 1030,
  HEADER = 208,
  MINIMUNTABLE = 110,
  SINGLE_REGISTER = 21,
  TABLEHEADER = 38,
  TITLE = 66,
  USER_NAME = 36
}

function R1() {
  const {
    reports: {
      reportsResources: {
        R1Data: { data },
        R1Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const pages = useMemo(() => {
    if (!data.length && !header.length) {
      return [
        [
          <TitleReport title="web.report.1.title" />,
          <SectionHeader />,
          <Empty />
        ]
      ]
    }

    const tempPages: JSX.Element[][] = []

    let activeUserName = ''
    let activeUserNumber = 0
    let index = 0
    let isFirtPage = true
    let totalSum = 0
    const receiptsImages = data.filter(item => item.image_href) || []

    // Make pages containing receipts grouped by owner //
    do {
      const page: JSX.Element[] = []
      let avaliableSpace = mesures.A4_PORTRAIT

      avaliableSpace -= mesures.TITLE
      page.push(<TitleReport title="web.report.1.title" />)

      if (isFirtPage) {
        isFirtPage = false
        avaliableSpace -= mesures.HEADER
        page.push(<SectionHeader />)
      }

      if (
        totalSum > 0 &&
        (index === data.length || data[index].user_number !== activeUserNumber)
      ) {
        avaliableSpace -= mesures.USER_NAME
        page.push(<Title level={4}>{activeUserName}</Title>)
        avaliableSpace -= 42
        page.push(<SectionTotal totalSum={totalSum} />)
        totalSum = 0
      }

      while (index < data.length && avaliableSpace > mesures.MINIMUNTABLE) {
        activeUserNumber = data[index].user_number
        activeUserName = data[index].user_name

        const maxRecordsPossible = data.slice(index, index + 42)
        const amountUserReceipts = maxRecordsPossible.filter(
          // eslint-disable-next-line
          receipt => receipt.user_number === data[index].user_number
        ).length

        if (amountUserReceipts > 0) {
          let spaceForReceipts = Math.trunc(
            (avaliableSpace - mesures.TABLEHEADER - mesures.USER_NAME) /
              mesures.SINGLE_REGISTER
          )

          const range =
            amountUserReceipts < spaceForReceipts
              ? amountUserReceipts
              : spaceForReceipts
          avaliableSpace -= mesures.USER_NAME
          page.push(<Title level={4}>{activeUserName}</Title>)

          const rangeToPrint = data.slice(index, index + range)
          totalSum += rangeToPrint.reduce((acc, curr) => {
            return acc + curr.total
          }, 0)

          avaliableSpace -=
            mesures.TABLEHEADER + mesures.SINGLE_REGISTER * range
          page.push(
            <WrapTableDiv>
              <TableDetail dataSource={rangeToPrint} />
            </WrapTableDiv>
          )

          if (amountUserReceipts === 1) {
            totalSum = 0
            avaliableSpace -= 20
            page.push(<WrapSpacer />)
          } else if (avaliableSpace >= 42) {
            avaliableSpace -= 42
            page.push(<SectionTotal totalSum={totalSum} />)
            totalSum = 0
          }

          index += range
        }
      }
      tempPages.push(page)
    } while (index < data.length || totalSum > 0)

    receiptsImages.sort((a, b) => (a.image_number < b.image_number ? 1 : 0))
    index = 0
    // Make pages containing images from receipts order by number //
    do {
      const page: JSX.Element[] = []
      page.push(<TitleReport title="web.report.1.title" />)
      page.push(<Title level={4} title="web.report.1.receipts.title" />)
      page.push(
        <SectionReceipts dataSource={receiptsImages.slice(index, index + 4)} />
      )
      index += 4
      tempPages.push(page)
    } while (index < receiptsImages.length)

    return tempPages
  }, [data, header])

  return (
    <>
      <OptionsBar />
      {pages.map((item, index) => (
        <WrapPage key={index} className="print" pageShape={A4_PORTRAIT}>
          <WrapPageContent>
            {item.map((t, i) => (
              <React.Fragment key={i}>{t}</React.Fragment>
            ))}
          </WrapPageContent>
          <Footer pagination={{ x: index + 1, y: pages.length }} />
        </WrapPage>
      ))}
    </>
  )
}

export default R1
